import React, { useState, useEffect } from 'react';
import { ClockIcon as Clock } from '@heroicons/react/24/outline';
import TimeTracker from '../components/time-tracking/TimeTracker';
import TimeStatistics from '../components/time-tracking/TimeStatistics';
// import UsageBillingDisplay from '../components/billing/UsageBillingDisplay'; // TODO: billing 컴포넌트 구현 필요
import TimeAlertDisplay from '../components/notification/TimeAlertDisplay';

const TimeTrackingPage: React.FC = () => {
  const [currentUsageMinutes, setCurrentUsageMinutes] = useState(0);
  const [ticketXCircle, setTicketXCircle] = useState({
    id: 'mock_ticket',
    type: 'time',
    remaining_time: 120
  });
  const [currentSessionId, setCurrentSessionId] = useState<string | undefined>();
  const [currentUserId] = useState('user123'); // 실제로는 auth context에서 가져옴

  // TimeTracker에서 현재 사용 시간 업데이트 받기
  const handleUsageUpdate = (usageMinutes: number) => {
    setCurrentUsageMinutes(usageMinutes);
  };

  // 세션 시작시 sessionId 설정
  const handleSessionStart = (sessionId: string) => {
    setCurrentSessionId(sessionId);
  };

  // 시간 연장 요청 처리
  const handleExtensionRequest = (minutes: number, paymentMethod: string) => {
    // 실제로는 결제 처리 및 세션 연장
  };

  // 자동 연장 설정 변경
  const handleAutoExtendToggle = (enabled: boolean, duration: number) => {
    // 실제로는 자동 연장 설정 저장
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 페이지 헤더 */}
        <div className="mb-8">
          <div className="flex items-center mb-2">
            <Clock className="h-8 w-8 text-blue-600 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">시간 관리</h1>
          </div>
          <p className="text-gray-600">실시간으로 사용 시간을 추적하고 과금 정보를 확인하세요.</p>
        </div>

        {/* 컨텐츠 그리드 */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          {/* 시간 추적기 */}
          <div className="xl:order-1">
            <TimeTracker />
          </div>

          {/* 통계 및 알림 */}
          <div className="xl:order-2 space-y-6">
            <TimeStatistics />
            
            {/* 실시간 알림 */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex items-center mb-4">
                <div className="h-5 w-5 bg-blue-500 rounded-full mr-2"></div>
                <h3 className="text-lg font-medium text-gray-900">실시간 알림</h3>
              </div>
              <TimeAlertDisplay
                userId={currentUserId}
                sessionId={currentSessionId}
                onExtensionRequest={handleExtensionRequest}
                onAutoExtendToggle={handleAutoExtendToggle}
              />
            </div>
          </div>

          {/* 사용량 기반 과금 */}
          <div className="xl:order-3">
            {/* TODO: billing 컴포넌트 구현 후 주석 해제
            <UsageBillingDisplay
              currentUsageMinutes={currentUsageMinutes}
              ticketXCircle={ticketXCircle}
              onPaymentRequired={(amount) => {
                // 결제 필요시 처리 로직
              }}
            />
            */}
          </div>
        </div>

        {/* 도움말 섹션 */}
        <div className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 border border-blue-200">
          <h3 className="text-lg font-medium text-gray-900 mb-4">시간 추적 사용법</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3 mt-0.5">1</div>
              <div>
                <div className="font-medium text-gray-900">좌석 선택</div>
                <div className="text-gray-600">사용할 좌석을 선택합니다.</div>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3 mt-0.5">2</div>
              <div>
                <div className="font-medium text-gray-900">이용권 선택</div>
                <div className="text-gray-600">사용할 이용권 타입을 선택합니다.</div>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3 mt-0.5">3</div>
              <div>
                <div className="font-medium text-gray-900">시간 추적 시작</div>
                <div className="text-gray-600">실시간으로 시간이 차감됩니다.</div>
              </div>
            </div>
          </div>
          
          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="p-4 bg-white rounded-lg border border-blue-200">
              <h4 className="font-medium text-gray-900 mb-2 flex items-center">
                <Clock className="h-4 w-4 mr-2" />
                시간 추적 기능
              </h4>
              <ul className="space-y-1 text-sm text-gray-600">
                <li>• <strong>실시간 추적:</strong> 5초마다 사용 시간이 업데이트됩니다</li>
                <li>• <strong>일시정지/재개:</strong> 필요시 시간 추적을 일시정지할 수 있습니다</li>
                <li>• <strong>자동 종료:</strong> 시간이 만료되면 자동으로 종료됩니다</li>
                <li>• <strong>시간 경고:</strong> 30분, 10분, 5분, 1분 전 자동 알림</li>
                <li>• <strong>즉시 연장:</strong> 알림에서 바로 시간 연장 가능</li>
                <li>• <strong>자동 연장:</strong> 설정 시 자동으로 시간 연장</li>
                <li>• <strong>상세 통계:</strong> 일별, 주별, 월별 사용 패턴을 분석합니다</li>
              </ul>
            </div>
            
            <div className="p-4 bg-white rounded-lg border border-green-200">
              <h4 className="font-medium text-gray-900 mb-2 flex items-center">
                <div className="h-4 w-4 bg-green-500 rounded mr-2"></div>
                사용량 기반 과금
              </h4>
              <ul className="space-y-1 text-sm text-gray-600">
                <li>• <strong>실시간 과금:</strong> 현재 사용량에 따른 예상 요금을 실시간 계산</li>
                <li>• <strong>초과 요금:</strong> 시간 초과시 분당 30원 부과 (5분까지 무료)</li>
                <li>• <strong>환불 정책:</strong> 30분 이상 미사용시 분당 25원 환불</li>
                <li>• <strong>자동 결제:</strong> 1,000원 이하는 자동 결제, 초과시 수동 결제</li>
                <li>• <strong>정산 내역:</strong> 과거 초과 요금 및 환불 내역 조회 가능</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeTrackingPage;